import type { Box, BoxType } from '../types';

/** Sessão do módulo Rede — separada da sessão do painel Farisx. */
export const SESSION_KEY = '@farisx/rede-session';
export const STATUS_OPTIONS = ['', 'montada', 'montada s/ sinal'] as const;
export const TYPE_OPTIONS: BoxType[] = ['CTO', 'CEP', 'CEO'];
export const SPLITTER_OPTIONS = ['', '1x1/8', '2x1/8', '3x1/8', '1x1/16', '2x1/16', '3x1/16'] as const;

export const normType = (v: unknown): BoxType | '' => {
  const x = String(v || '').trim().toUpperCase();
  return (TYPE_OPTIONS as string[]).includes(x) ? (x as BoxType) : '';
};

export const parseCoord = (v: unknown): number => {
  if (v === undefined || v === null || v === '') return NaN;
  return Number.parseFloat(String(v).replace(',', '.'));
};

export const markerColor = (type: string): string =>
  ({ CTO: '#DC2626', CEP: '#2563EB', CEO: '#16A34A' } as Record<string, string>)[type] || '#6B7280';

export function normalizeRemoteBox(raw: any, idx = 0): Box | null {
  const latitude = parseCoord(raw?.latitude);
  const longitude = parseCoord(raw?.longitude);
  const type = normType(raw?.type);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || !type) return null;

  const id = String(raw?.id ?? raw?.boxId ?? '').trim();
  const name = String(raw?.name ?? '').trim();

  return {
    id: id || `cx-${idx + 1}`,
    name: name || `Caixa ${id || idx + 1}`,
    type,
    splitter: String(raw?.splitter || '').trim(),
    pop: String(raw?.pop || '').trim(),
    latitude,
    longitude,
    signal: String(raw?.signal || ''),
    status: String(raw?.status || ''),
    images: Array.isArray(raw?.images) ? raw.images.filter((it: unknown) => typeof it === 'string' && !!it) : [],
    LastEditor: String(raw?.LastEditor || ''),
    LastEditDate: raw?.LastEditDate || null,
    LastEdition: String(raw?.LastEdition || ''),
    montadoPor: String(raw?.montadoPor || ''),
    montadoEm: raw?.montadoEm || null
  };
}

export function csvRowToBox(row: Record<string, any>, idx: number): Box | null {
  const norm: Record<string, any> = {};
  Object.keys(row || {}).forEach((k) => {
    norm[String(k).trim().toLowerCase().replace(/[\s-]+/g, '_')] = row[k];
  });
  const latitude = parseCoord(norm.latitude ?? norm.lat);
  const longitude = parseCoord(norm.longitude ?? norm.lng ?? norm.lon);
  const type = normType(norm.type ?? norm.tipo);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || !type) return null;

  const id = String(norm.id ?? norm.caixa_id ?? norm.box_id ?? norm.codigo ?? `cx-import-${idx + 1}`).trim();
  return {
    id,
    name: String(norm.name ?? norm.nome ?? norm.descricao ?? `Caixa ${id}`).trim(),
    type,
    splitter: String(norm.splitter || '').trim(),
    pop: String(norm.pop || '').trim(),
    latitude,
    longitude,
    signal: '',
    status: '',
    images: []
  };
}
